import { Box, Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import React from 'react';
import { ContactCaptureType } from '../../types';

export type PreviewState = 'form' | 'success';

const compactToggleSx = {
  '& .MuiToggleButton-root': {
    px: 1,
    py: 0.25,
    fontSize: 11,
    lineHeight: 1.5,
    minHeight: 24,
  },
};

type Props = {
  previewState: PreviewState;
  type: ContactCaptureType;
  onPreviewStateChange: (state: PreviewState) => void;
};

export const ContactCapturePreviewToolbar = ({
  onPreviewStateChange,
  previewState,
  type,
}: Props) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    sx={{ flexShrink: 0, flexWrap: 'wrap', gap: 1 }}
  >
    <Box>
      <Typography variant="subtitle2" fontWeight={700}>Live preview</Typography>
      <Typography variant="caption" color="text.secondary">
        {type === 'popup' ? 'Website popup' : 'Embedded form'}
      </Typography>
    </Box>
    <ToggleButtonGroup
      exclusive
      size="small"
      value={previewState}
      onChange={(_, value: PreviewState | null) => value && onPreviewStateChange(value)}
      aria-label="Preview state"
      sx={compactToggleSx}
    >
      <ToggleButton value="form" aria-label="Form preview">Form</ToggleButton>
      <ToggleButton value="success" aria-label="Success message preview">Success</ToggleButton>
    </ToggleButtonGroup>
  </Stack>
);

